import { scoops } from "@/mocks/home";

export default function ScoopGrid() {
  return (
    <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
      <div className="flex items-center gap-4 mb-6 md:mb-8">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap">
          最新爆料
        </h2>
        <span className="flex-1 h-px bg-background-300/70"></span>
        <div className="hidden sm:flex items-center gap-2">
          {["全部", "深挖", "线索", "跟进"].map((f, i) => (
            <span
              key={f}
              className={`px-3 py-1.5 rounded-full font-label text-xs cursor-pointer whitespace-nowrap transition-colors ${
                i === 0
                  ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {f}
            </span>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {scoops.map((item) => (
          <article
            key={item.title}
            className="group flex flex-col rounded-lg overflow-hidden border border-background-200/80 bg-background-50 hover:border-primary-300 transition-colors"
          >
            <div className="relative w-full h-[180px] bg-background-200">
              <img
                src={item.image}
                alt={`黑料看料 爆料：${item.title}`}
                title={`黑料看料 ${item.title} 内幕线索`}
                className="w-full h-full object-top object-cover group-hover:scale-[1.03] transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded bg-accent-500 text-accent-950 font-label text-[11px] font-medium">
                {item.tag}
              </span>
            </div>
            <div className="flex flex-col flex-1 p-4">
              <h3 className="font-heading text-base md:text-lg font-semibold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                {item.title}
              </h3>
              <p className="mt-2 font-label text-sm leading-relaxed text-foreground-600 flex-1">
                {item.excerpt}
              </p>
              <div className="mt-4 pt-3 border-t border-background-200/70 flex items-center justify-between font-label text-xs text-foreground-400">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-fire-line text-primary-500"></i>
                  热度 {item.heat}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-chat-3-line"></i>
                  {item.comments} 条讨论
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}